export const getEventTargetLocation = ({
  componentName,
  elementPosition,
}: {
  componentName: string;
  elementPosition: string;
}) => [componentName, elementPosition].filter(Boolean).join("-");

export const getEventName = ({
  targetLocation,
  target,
  action,
}: {
  targetLocation: string;
  target?: string;
  action: string;
}) => [targetLocation, target, action].filter(Boolean).join("_");
